import React, { useState, useEffect, useRef } from 'react';
import { numbersToLocaleString } from '../services';
import { currencyDecimal } from 'services/currency';

const InputPrice = (props) => {
  const [inputValue, setInputValue] = useState(props.value || '');
  const inputEl = useRef(null);

  const onChange = (e) => {
    setInputValue(e.target.value);
  };

  const onKeyDown = e => {
    const { decimal } = currencyDecimal();
    const reg = decimal === '.' ? new RegExp(/\./g) : new RegExp(/,/g);
    const isHaveDecimal = inputValue && inputValue.match(reg);
    if (e.key.match(/\d/)
      || e.key.match(/arrow/i)
      || e.key.match(/tab/i)
      || e.key.match(/backspace/i)       
      || e.key.match(/shift/i)
      || e.key.match(/delete/i)
      || e.key.match(reg) && (inputValue && (!isHaveDecimal || isHaveDecimal.length < 1))) {
      return;
    } else if(e.key.match(/enter/i)){
      if(inputEl) inputEl.current.blur();
    } else {
      e.preventDefault();
    }
  };

  const inputOnBlur = () => {
    const { onBlur } = props;
    const val = numbersToLocaleString(inputValue);
    setInputValue(val);
    if (onBlur) onBlur(val);
  };

  useEffect(() => {
    const { onChange } = props;
    if (onChange) onChange(numbersToLocaleString(inputValue));
  }, [inputValue]);

  const { onFocus, style } = props;

  return (
    <input
      ref={inputEl}
      style={style}
      value={inputValue}
      onFocus={onFocus}
      onBlur={inputOnBlur}
      onKeyDown={onKeyDown}
      onChange={onChange}
    />
  );
};

export default InputPrice;
